export type CompanyBand = 'ready' | 'developing' | 'needs_practice';

export const BAND_META: Record<CompanyBand, { label: string; badgeClass: string; dotClass: string; barClass: string }> = {
  ready:          { label: 'Ready',          badgeClass: 'bg-emerald-50 text-emerald-700', dotClass: 'bg-emerald-500', barClass: 'bg-emerald-500' },
  developing:     { label: 'Developing',     badgeClass: 'bg-amber-50 text-amber-700',     dotClass: 'bg-amber-500',   barClass: 'bg-amber-500' },
  needs_practice: { label: 'Needs Practice', badgeClass: 'bg-red-50 text-red-700',          dotClass: 'bg-red-500',    barClass: 'bg-red-500' },
};
